module.exports = __webpack_public_path__ + "media/icons/cookiewow-ce8bf247.svg";